
<div style="display: flex; justify-content: flex-end; gap: 8px; margin-bottom: 12px;">
    <button [useExistingCss]="true" class="noPrint" mat-raised-button
        color="primary" printSectionId="print-section" ngxPrint>
        Print
    </button>
    <button mat-dialog-close class="btn noPrint">
        Close
    </button>
</div>
<table class="print-order-summary-table">
     <tr class="title-row">
    <td colspan="2">
      Print Order
</td>
      <td colspan="3">
      IssueName-{{ issueName }}
      IssueDate-{{ issuedate }}
    </td>
  </tr>
    <tr class="section-header">
        <td colspan="2"></td>
        <td colspan="3">मराठी</td>
    </tr>
    <tr class="col-header">
        <td>Office Representative</td>
        <td>Prati</td>
        <td>जमा</td>
        <td>येणे</td>
        <td>एकूण</td>
    </tr>

    <!-- Loading state -->
    <tr class="status-row" *ngIf="isLoadingSummary">
        <td colspan="4">Loading...</td>
    </tr>

    <!-- Error state -->
    <tr class="status-row error" *ngIf="!isLoadingSummary && summaryError">
        <td colspan="4">{{ summaryError }}</td>
    </tr>

    <!-- Empty state -->
    <tr class="status-row" *ngIf="!isLoadingSummary && !summaryError && printOrderSummary.length === 0">
        <td colspan="4">No office representative data found.</td>
    </tr>

    <!-- Auto-fetched, read-only rows: one per office representative -->
    <tr *ngFor="let item of printOrderSummary">
        <td class="rep-name">{{ item.name }}</td>
        <td>{{item.prati}}</td>
        <td>{{ item.jama }}</td>
        <td>{{ item.bakiAnki }}</td>
        <td class="ekun-cell">{{ item.ekun }}</td>
    </tr>

    <!-- Totals row for all representatives -->
    <tr class="totals-row">
        <td>Grand Total</td>
        <td>{{totalprati}}</td>
        <td>{{ totalJama }}</td>
        <td>{{ totalBakiAnki }}</td>
        <td class="ekun-cell">{{ totalEkun }}</td>
    </tr>

    <tr class="spacer-row">
        <td colspan="4"></td>
    </tr>

    <!-- Manual entry rows: संपादकीय / जाहिरात / कार्यालय -->
    <tr *ngFor="let entry of additionalEntries; let i = index">
        <td class="entry-name" colspan="2">{{ entry.name }}</td>
        <td class="entry-label" colspan="2">{{ entry.label }}</td>
        <td class="entry-value">
            <input type="number" value="{{ entry.value }}"
                   (change)="updateAdditionalEntry($event, i)">
        </td>
    </tr>

    <!-- Grand total (मराठी) -->
    <tr class="grand-total-row">
        <td class="label-cell" colspan="4">मराठी</td>
        <td>{{ grandTotalMarathi }}</td>
    </tr>
</table>